(function() {
    var currencySymbol = '$';
    
    // 自动抓取货币符号
    var existingPriceEl = document.querySelector('.price-item--regular, .price__current, .product-price');
    if (existingPriceEl) {
        var priceText = existingPriceEl.textContent.trim();
        var symbolMatch = priceText.match(/^[^\d]+/);
        if (symbolMatch && symbolMatch[0]) { currencySymbol = symbolMatch[0].trim(); }
    }
    
    var productVariants = window.wctStickyVariants || [];
    var productName = window.wctProductName || "";

    function formatMoney(cents) {
        var amount = parseInt(cents);
        if (isNaN(amount) || amount <= 0) return currencySymbol + '0.00';
        return currencySymbol + (amount / 100).toFixed(2);
    }

    function getVariantDisplayCents(variant) {
        if (!variant) return 0;
        var map = window.wctVariantShowPrices || {};
        var mapped = map[variant.id];
        if (mapped == null) mapped = map[String(variant.id)];
        var cents = parseInt(mapped, 10);
        if (mapped != null && mapped !== '' && !isNaN(cents)) return cents;
        return variant.price;
    }

    function elevateStickyBar() {
        var stickyBar = document.getElementById('wct-sticky-bar');
        if (stickyBar && stickyBar.parentNode !== document.body) {
            document.body.appendChild(stickyBar);
        }
    }

    function browserBottomInset() {
        var vv = window.visualViewport;
        if (!vv) return 0;
        // Pulling past the top makes offsetTop negative. Keep both bars on the page bottom.
        if (vv.offsetTop < 0) return 0;
        return Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    }

    // Keep the sticky purchase bar above the mobile toolbar and Chrome's collapsing bottom UI.
    function placeStickyAboveToolbar() {
        var stickyBar = document.getElementById('wct-sticky-bar');
        if (!stickyBar) return;

        var nav = document.querySelector('.header-mobile-navigation');
        if (window.innerWidth >= 768) {
            stickyBar.style.bottom = '';
            if (nav) nav.style.bottom = '';
            return;
        }

        var browserInset = browserBottomInset();
        if (nav) nav.style.bottom = browserInset + 'px';
        var navHeight = nav ? Math.ceil(nav.getBoundingClientRect().height) : 55;
        stickyBar.style.bottom = (browserInset + navHeight + 12) + 'px';
    }

    var stickyPlaceFrame = 0;
    function scheduleStickyPlacement() {
        if (stickyPlaceFrame) return;
        stickyPlaceFrame = window.requestAnimationFrame(function() {
            stickyPlaceFrame = 0;
            placeStickyAboveToolbar();
        });
    }

    // 2. 静态高度注入：消除原本 sub-footer 的 40px 冗余边距
    function initFixedFooterPadding() {
        var stickyBar = document.getElementById('wct-sticky-bar');
        var footer = document.querySelector('.footer') || document.querySelector('footer') || document.getElementById('shopify-section-footer');
        
        // 精准抓取 Vision 主题底部的 sub-footer 菜单
        var subFooter = document.querySelector('.premium-footer .sub-footer');
        
        if (stickyBar) {
            var barHeight = stickyBar.offsetHeight || 90; 
            
            if (window.innerWidth < 768) {
                var nav = document.querySelector('.header-mobile-navigation');
                var navHeight = nav ? Math.ceil(nav.getBoundingClientRect().height) : 65;
                var totalMobilePadding = barHeight + navHeight + browserBottomInset() + 15;
                if (footer) {
                    footer.style.setProperty('padding-bottom', totalMobilePadding + 'px', 'important');
                } else {
                    document.body.style.setProperty('padding-bottom', totalMobilePadding + 'px', 'important');
                }

                // 核心修复：探测到当前模块存在，直接将 sub-footer 默认的 40px 边距斩断归零
                if (subFooter) {
                    subFooter.style.setProperty('padding-bottom', '0px', 'important');
                }
            } else {
                // PC 端垫高
                if (footer) {
                    footer.style.setProperty('padding-bottom', (barHeight + 20) + 'px', 'important');
                }
            }
        }
    }

    // 3. 进入产品详情页即展示底部固定加购条
    function showStickyBar() {
        var stickyBar = document.getElementById('wct-sticky-bar');
        if (!stickyBar) return;
        stickyBar.classList.add('sticky--visible');
        stickyBar.classList.remove('sticky--hidden');
        var inner = stickyBar.querySelector('.wct-sticky-bar-inner');
        if (inner) inner.style.display = 'flex';
    }

    // 4. 镜像同步主加购按钮状态
    function syncStickyButtonState() {
        var mainATC = document.getElementById('AddToCart') || document.querySelector('button[name="add"]');
        var stickyATC = document.getElementById('AddToCartSticky');
        var stickyBuyNow = document.getElementById('wct-sticky-bar-buy-now');
        if (!mainATC || !stickyATC) return;

        stickyATC.disabled = mainATC.disabled;
        if (stickyBuyNow) stickyBuyNow.style.display = mainATC.disabled ? 'none' : 'flex';
        
        var mainTextEl = mainATC.querySelector('.single-add-to-cart-button--text');
        var stickyTextEl = stickyATC.querySelector('.single-add-to-cart-button--text');
        if (mainTextEl && stickyTextEl) {
            stickyTextEl.textContent = mainTextEl.textContent.trim();
        }
        
        stickyATC.classList.toggle('sold-out', mainATC.classList.contains('sold-out'));
    }

    function resolveBaseVariantData() {
        var masterIdInput = document.querySelector('.wct-hidden-master-id') || document.querySelector('input[name="id"]');
        var targetId = masterIdInput ? parseInt(masterIdInput.value) : null;
        var activeVariant = productVariants.find(function(v) { return v.id === targetId; }) || productVariants[0];

        var result = {
            variant: activeVariant,
            colorName: "",
            packageName: "",
            imgSrc: ""
        };

        var activeColorEl = document.querySelector('.wct-color-label.is-active .wct-color-text');
        if (activeColorEl) {
            result.colorName = activeColorEl.textContent.trim();
        } else {
            result.colorName = activeVariant.option1 !== 'Default Title' ? activeVariant.option1 : "";
        }

        var activePkgEl = document.querySelector('.wct-package-wrapper.is-active .wct-package-name');
        if (activePkgEl) {
            result.packageName = activePkgEl.textContent.trim();
            var pkgImg = activePkgEl.closest('.wct-package-wrapper').querySelector('.wct-package-img img');
            if (pkgImg) result.imgSrc = pkgImg.getAttribute('src');
        } else {
            result.packageName = activeVariant.option2 || "";
        }

        if (!result.imgSrc && activeVariant.featured_image) {
            result.imgSrc = activeVariant.featured_image.src;
        }

        return result;
    }

    function addToCartViaAjax(items, callback) {
        var rootUrl = window.Shopify?.routes?.root || '/';
        
        fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ 
                items: items,
                sections: "cart-drawer,cart-icon-bubble"
            })
        })
        .then(function(response) {
            if (!response.ok) {
                return response.json().then(function(err) { throw err; });
            }
            return response.json();
        })
        .then(function(data) {
            document.dispatchEvent(new CustomEvent('cart:updated', { 
                bubbles: true,
                detail: { cart: data }
            }));
            
            document.dispatchEvent(new Event('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new Event('cart:change', { bubbles: true }));
            
            if (window.theme && typeof window.theme.cartDrawerOpen === 'function') {
                window.theme.cartDrawerOpen();
            }
            
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
            } else if (cartDrawer) {
                cartDrawer.classList.add('is-active');
            }
            
            var sideCart = document.querySelector('.side-cart');
            if (sideCart) {
                sideCart.classList.add('active');
            }
            
            if (callback) callback(null, data);
        })
        .catch(function(error) {
            console.error('Add to cart error:', error);
            if (callback) callback(error, null);
        });
    }

    window.wctUpdateStickyInfo = function() {
        var data = resolveBaseVariantData();
        var activeVariant = data.variant;
        if (!activeVariant) return;

        var qtyInput = document.querySelector('.wct-hidden-master-qty') || document.querySelector('input[name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        var titleDom = document.getElementById('wct-sticky-bar-title');
        if (titleDom) {
            var finalTitle = "";
            var color = data.colorName;
            var pkg = data.packageName;

            if (color && pkg && pkg !== 'Default Title') {
                finalTitle = pkg;
            } else if (color) {
                finalTitle = color;
            } else {
                finalTitle = productName;
            }

            var fbtCount = document.querySelectorAll('.wct-fbt-bundle-item.active').length;
            if (fbtCount > 0) {
                finalTitle += ' + ' + fbtCount + ' item' + (fbtCount > 1 ? 's' : '');
            }
            titleDom.textContent = finalTitle;
        }

        var displayUnit = getVariantDisplayCents(activeVariant);
        var displayTotal = displayUnit * qty;
        var chargeTotal = activeVariant.price * qty;
        var compareTotal = (activeVariant.compare_at_price || activeVariant.price) * qty;
        var saveTotal = 0;
        if (activeVariant.compare_at_price > displayUnit) {
            saveTotal += (activeVariant.compare_at_price - displayUnit) * qty;
        }

        document.querySelectorAll('.wct-fbt-bundle-item.active').forEach(function(item) {
            var p = parseInt(item.dataset.price);
            if (!isNaN(p)) {
                displayTotal += p;
                chargeTotal += p;
            }
            var select = item.querySelector('.bundle-variant-select');
            var addedCompare = p;
            if (select && select.options[select.selectedIndex]) {
                var cp = parseInt(select.options[select.selectedIndex].dataset.comparePrice);
                addedCompare = isNaN(cp) ? p : cp;
            }
            compareTotal += addedCompare;
            if (!isNaN(p) && !isNaN(addedCompare) && addedCompare > p) {
                saveTotal += addedCompare - p;
            }
        });

        var priceEl = document.getElementById('wct-sticky-bar-price');
        if (priceEl) priceEl.textContent = formatMoney(displayTotal);
        
        var compEl = document.getElementById('wct-sticky-bar-compare-price');
        var saveEl = document.getElementById('wct-sticky-bar-save-badge');

        if (compEl) {
            if (compareTotal > chargeTotal) {
                compEl.textContent = formatMoney(compareTotal);
                compEl.classList.add('is-visible');
            } else {
                compEl.classList.remove('is-visible');
            }
        }
        if (saveEl) {
            if (saveTotal > 0) {
                saveEl.textContent = 'Save ' + formatMoney(saveTotal);
                saveEl.classList.add('is-visible');
            } else {
                saveEl.classList.remove('is-visible');
            }
        }

        var thumbDom = document.getElementById('wct-sticky-bar-thumb-img');
        if (thumbDom && data.imgSrc) {
            thumbDom.src = data.imgSrc;
        }

        syncStickyButtonState();
    };

    function setupObserver() {
        var mainATC = document.getElementById('AddToCart') || document.querySelector('button[name="add"]');
        if (!mainATC) return;
        var observer = new MutationObserver(syncStickyButtonState);
        observer.observe(mainATC, { attributes: true, childList: true, subtree: true });
    }

    // 全局事件路由监听
    document.addEventListener('click', function(e) {
        var stickyATC = e.target.closest('#AddToCartSticky');
        if (stickyATC) {
            e.preventDefault();
            e.stopPropagation();
            if (stickyATC.disabled) return;

            var fbtItems = [];
            if (window.wctFbtBundleInstance && typeof window.wctFbtBundleInstance.getAdditionalFbtItems === 'function') {
                fbtItems = window.wctFbtBundleInstance.getAdditionalFbtItems();
            } else {
                document.querySelectorAll('.wct-fbt-bundle-item.active').forEach(function(item) {
                    var vid = parseInt(item.dataset.variantId);
                    if (vid && !isNaN(vid)) fbtItems.push({ id: vid, quantity: 1 });
                });
            }

            if (fbtItems.length === 0) {
                var mainATC = document.getElementById('AddToCart') || document.querySelector('button[name="add"]');
                if (mainATC) mainATC.click();
                return;
            }

            var masterIdInput = document.querySelector('.wct-hidden-master-id') || document.querySelector('input[name="id"]');
            var mainId = masterIdInput ? parseInt(masterIdInput.value) : null;
            if (!mainId) return;

            var qtyInput = document.querySelector('.wct-hidden-master-qty') || document.querySelector('input[name="quantity"]');
            var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

            var itemsToAdd = [{ id: mainId, quantity: qty }].concat(fbtItems);

            var loadingOverlay = stickyATC.querySelector('.loading-overlay');
            var buttonText = stickyATC.querySelector('.single-add-to-cart-button--text');
            if (loadingOverlay) loadingOverlay.style.display = 'inline-block';
            if (buttonText) buttonText.textContent = 'Adding...';
            stickyATC.disabled = true;

            addToCartViaAjax(itemsToAdd, function(err, data) {
                if (loadingOverlay) loadingOverlay.style.display = 'none';
                if (buttonText) buttonText.textContent = 'Add to cart';
                stickyATC.disabled = false;
            });
            return;
        }

        var buyNowBtn = e.target.closest('#wct-sticky-bar-buy-now');
        if (buyNowBtn) {
            e.preventDefault();
            e.stopPropagation();

            if (window.Shopify && window.Shopify.designMode) {
                alert('Notice: Checkout navigation is disabled inside the Shopify Theme Editor.');
                return;
            }

            var masterIdInput = document.querySelector('.wct-hidden-master-id') || document.querySelector('input[name="id"]');
            var mainId = masterIdInput ? masterIdInput.value : null;
            var qty = document.querySelector('.wct-hidden-master-qty')?.value || 1;
            if (!mainId) return;
            var rootUrl = window.Shopify?.routes?.root || '/';
            var checkoutUrl = rootUrl + 'cart/' + mainId + ':' + qty;
            document.querySelectorAll('.wct-fbt-bundle-item.active').forEach(function(item) {
                if (item.dataset.variantId) checkoutUrl += ',' + item.dataset.variantId + ':1';
            });
            window.location.href = checkoutUrl;
        }
    }, true);

    window.addEventListener('wct:variant:synced', window.wctUpdateStickyInfo);
    window.addEventListener('wct:fbt:updated', window.wctUpdateStickyInfo);

    // ============================================
    // 统一初始化入口
    // ============================================
    window.addEventListener('DOMContentLoaded', function() {
        elevateStickyBar();
        showStickyBar();
        placeStickyAboveToolbar();
        setupObserver();
        
        // 核心稳固：初始化时，一次性把 sub-footer 的 40px 融掉
        setTimeout(initFixedFooterPadding, 400); 

        setTimeout(window.wctUpdateStickyInfo, 100);
        setTimeout(window.wctUpdateStickyInfo, 500); 
        setTimeout(window.wctUpdateStickyInfo, 2000);

        window.addEventListener('wct:variant:synced', function() {
            setTimeout(syncStickyButtonState, 50);
            setTimeout(initFixedFooterPadding, 100); 
        });
    });

    // 若脚本在 DOMContentLoaded 之后才执行，立即展示
    if (document.readyState !== 'loading') {
        elevateStickyBar();
        showStickyBar();
        placeStickyAboveToolbar();
    }

    window.addEventListener('resize', function() {
        scheduleStickyPlacement();
        initFixedFooterPadding();
    });
    window.addEventListener('orientationchange', scheduleStickyPlacement);
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleStickyPlacement);
        window.visualViewport.addEventListener('scroll', scheduleStickyPlacement);
    }
})();